import { EMAIL_NOTIFICATIONS_SECTION_ID } from '@/routes/_auth/_modules/crt/settings/-components/settings-anchors'
import { createFileRoute, redirect } from '@tanstack/react-router'

// The notifications editor moved from its Admin page to the settings page's Email Notifications
// section. Sends old links and bookmarks there.
export const Route = createFileRoute('/_auth/_modules/crt/admin/notifications/$')({
  beforeLoad: () => {
    throw redirect({ to: '/crt/settings', hash: EMAIL_NOTIFICATIONS_SECTION_ID, replace: true })
  },
})
